import React, { useEffect, useState, useMemo } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSearch, FaChevronLeft, FaChevronRight, FaEdit, FaTrash, FaEye } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import '../../HR Manager/screens/Employees.css'
import API_BASE_URL from '../../../config/api'

const HREmployees = () => {
  const baseUrl = API_BASE_URL
    const [employees, setEmployees] = useState([])
  const [departments, setDepartments] = useState([])
  const [costCenters, setCostCenters] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [selectedDepartment, setSelectedDepartment] = useState(null)
  const [selectedCostCenter, setSelectedCostCenter] = useState(null)
  const [page, setPage] = useState(1)
  const [rowsPerPage] = useState(10)
  const [userDepartment, setUserDepartment] = useState(null);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true)
      try {
        const token = Cookies.get('token')
        const [empRes, depRes, ccRes] = await Promise.all([
          axios.get(`${baseUrl}/api/department-employees/`, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(`${baseUrl}/api/departments/`, { headers: { 'Authorization': `Bearer ${token}` } }),
          axios.get(`${baseUrl}/api/course-centers/`, { headers: { 'Authorization': `Bearer ${token}` } })
        ])
        console.log(empRes.data)
        setEmployees(empRes.data)
        setDepartments(depRes.data)
        setCostCenters(ccRes.data)
      } catch (err) {
        // handle error
      } finally {
        setLoading(false)
      }
    }
    fetchAll()
  }, [])

  const departmentOptions = useMemo(() => departments.map(dep => ({
    value: dep.id,
    label: dep.course_center_name ? `${dep.name} (${dep.course_center_name})` : dep.name
  })), [departments])

  const costCenterOptions = useMemo(() => costCenters.map(cc => ({
    value: cc.id,
    label: cc.name
  })), [costCenters])

  // Pagination logic
  const totalPages = Math.ceil(employees.length / rowsPerPage)
  const paginatedEmployees = employees.slice((page - 1) * rowsPerPage, page * rowsPerPage)

  const handleSearchChange = e => {
    setSearch(e.target.value)
    setPage(1)
  }
  const handleDepartmentChange = val => {
    setSelectedDepartment(val)
    setPage(1)
  }
  const handleCostCenterChange = val => {
    setSelectedCostCenter(val)
    setPage(1)
  }
  const handlePrevPage = () => setPage(p => Math.max(1, p - 1))
  const handleNextPage = () => setPage(p => Math.min(totalPages, p + 1))

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="employees-container">
        
        <div className="hr-content-wrapper">
          <div className="filters-bar">
            <div className="search-bar">
              <h2 style={{color: 'navy'}}>Department Employees</h2>
            </div>
            <div className="search-bar">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by name, national ID, or position..."
                value={search}
                onChange={handleSearchChange}
                className="search-input"
                disabled={loading}
                style={{width: '40%'}}
              />
            </div>
           
          </div>
          <div className="table-wrapper">
            <table className="employees-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Surname</th>
                  <th>National Id</th>
                  <th>Position</th>
                  <th>Progress</th>
                  <th>Actions</th>

                  
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={5} className="loading-row">
                      <div className="beat-loader">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                      </div>
                    </td>
                  </tr>
                ) : paginatedEmployees.length === 0 ? (
                  <tr><td colSpan={5} className="empty-row">No employees found.</td></tr>
                ) : (
                  paginatedEmployees.map(emp => {
                    const dep = departments.find(d => d.id === emp.department)
                    return (
                      <tr key={emp.id}>
                        <td>{emp.first_name}</td>
                        <td>{emp.last_name}</td>
                        <td>{emp.national_id}</td>
                        <td>{emp.position}</td>
                        <td>
                          <div className="progress-bar-container">
                            <div className="progress-bar-bg" style={{ position: 'relative' }}>
                              <div
                                className="progress-bar-fill"
                                style={{ backgroundColor: `${emp.performance_indicator}`, width: `${(emp.performance_progress || 0).toFixed(2)}%` }}
                              >
                                <span className="progress-bar-label-inside">
                                  {(emp.performance_progress || 0).toFixed(2)}%
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                        <Link
                            to={{
                              pathname: `/hr/department-employee/${emp.id}/goals`,
                            }}
                            state={{ employeeId: emp.id }}
                            style={{ textDecoration: 'none' }}
                          >
                            <button className="action-button view-button" title="View">
                              <FaEye />
                            </button>
                          </Link>
                          <Link
                            to={{
                              pathname: `/hr/employee-goals/${emp.id}/reviews`,
                            }}
                            state={{ employeeId: emp.id }}
                            style={{ textDecoration: 'none' }}
                          >
                            <button className='review-button' title="View">
                              Review Goals
                            </button>
                          </Link>
                          
                        </td>
                            


                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-bar">
            <button onClick={handlePrevPage} disabled={page === 1} className="pagination-btn"><FaChevronLeft /></button>
            <span className="pagination-info">Page {page} of {totalPages || 1}</span>
            <button onClick={handleNextPage} disabled={page === totalPages || totalPages === 0} className="pagination-btn"><FaChevronRight /></button>
          </div>
        </div>
    </div>
    </>
  )
}

export default HREmployees
